import { useLocation, useParams } from 'react-router-dom';
import { CMSPageView } from './CMSPageView';

interface CMSPageViewRouteProps {
  brandName?: string | null;
}

/** Wrapper that provides path and slug from the router to CMSPageView. */
export function CMSPageViewRoute({ brandName }: CMSPageViewRouteProps): JSX.Element {
  const location = useLocation();
  const params = useParams<{ slug: string }>();
  const path = location.pathname;
  const slug = params.slug ?? null;
  return <CMSPageView path={path} slug={slug} brandName={brandName} />;
}
